module.exports = __webpack_public_path__ + "img/medx-logo.30123b16.svg";